import z from 'zod';
import {contactMessageSourceSchema} from './ContactMessageSource';

export const contactMessageWriteSchema = z.object({
  name: z.string().min(1, 'Name is required'),
  email: z.email('Invalid email address'),
  message: z.string().min(1, 'Message is required'),
  uid: z.string().nullish().optional(),
  source: contactMessageSourceSchema,
});

export interface ContactMessageWrite extends z.infer<typeof contactMessageWriteSchema> {}
